(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('SettingDetailController', SettingDetailController);

    SettingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Setting'];

    function SettingDetailController($scope, $rootScope, $stateParams, entity, Setting) {
        var vm = this;

        vm.setting = entity;

        var unsubscribe = $rootScope.$on('valueconnectApp:settingUpdate', function(event, result) {
            vm.setting = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
